<button
  id="select-project"
  class="p-2 text-base disabled:bg-transparent hover:bg-trimble-gray hover:bg-opacity-20"
  (click)="showProjectPicker()"
>
  {{ projectName() }}
</button>
